import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import { inject, observer } from 'mobx-react';
import StripeCheckout from 'react-stripe-checkout';
import InvoiceDetail from './InvoiceDetail';

@inject('userStore')
@observer
class InvoicePayment extends Component {

  render(){
    const {invoice, token_handler, paymentOptionList, modalBackgroundHandler, public_key} = this.props;
    return (
      <React.Fragment>
        <div className="modal-header">
            <h4 className="modal-title">#{invoice.invoice_number}: {invoice.description}</h4>
            <button type="button" className="close" onClick={modalBackgroundHandler} aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className="modal-body">
          <InvoiceDetail invoice={invoice}/>
          <div className="card">
            <div className="card-body">

              <div className="card">
                <h2>Pay Invoice</h2>
                <p>{invoice.booking.business_name} Accepts the follow types of payment:</p>
                {paymentOptionList.length > 0 ?
                  paymentOptionList.map((option, index) => {
                    if (option.sys_payment_type_id !== 1){
                      return (
                        <div className="media bordered mb-10" key={index}>
                          <div className="media-body">
                            <p><strong>{option.sys_payment_type}</strong></p>
                            <p style={{whiteSpace:'pre-line'}}>{option.option_text}</p>
                          </div>
                        </div>
                      )
                    } else {
                      return (
                        <div className="media bordered mb-10" key={index}>
                          <div className="media-body">
                            <p><strong>Credit Card Online</strong></p>
                            {option.is_fee_passed ?
                              <p style={{whiteSpace:'pre-line'}}>Please note, credit card payments are assessed a passthru fee of ${invoice.passthru_amount_cc}</p>
                            : null}
                            <StripeCheckout
                              name={invoice.booking.business_name} // the pop-in header title
                              description={invoice.description} // the pop-in header subtitle
                              image={invoice.booking.business_img} // the pop-in header image (default none)
                              ComponentClass="div"
                              panelLabel="Pay Invoice" // prepended to the amount in the bottom pay button
                              amount={invoice.due_amount_cc_int} // cents
                              currency="USD"
                              stripeKey={public_key}
                              token={token_handler} // submit callback
                              // Note: `reconfigureOnUpdate` should be set to true IFF, for some reason
                              // you are using multiple stripe keys
                              reconfigureOnUpdate={false}
                              // Note: you can change the event to `onTouchTap`, `onClick`, `onTouchStart`
                              // useful if you're using React-Tap-Event-Plugin
                              >
                            </StripeCheckout>
                          </div>
                        </div>
                      )
                    }
                  }
                  )
                : <div className="alert alert-warning">Please contact your provider to make payment.</div>}
              </div>
              </div>
              <div className="card-footer">
                <h2 className="pull-right">Invoice Total: ${invoice.event_total}</h2>
              </div>
            </div>
          </div>
          <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={modalBackgroundHandler}>
                Close
              </button>
          </div>
        </React.Fragment>
    )
  }
}

export default InvoicePayment;



// WEBPACK FOOTER //
// ./src/components/client/InvoicePayment.js